/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVideoCross: {
  name: 'video-cross';
  data: string;
} = {
  name: 'video-cross',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 2.5A1.5 1.5 0 0 0 .5 4v8A1.5 1.5 0 0 0 2 13.5h9a1.5 1.5 0 0 0 1.5-1.5V9.207l2.146 2.147A.5.5 0 0 0 15.5 11V5a.5.5 0 0 0-.854-.354L12.5 6.793V4A1.5 1.5 0 0 0 11 2.5H2ZM11.5 8V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V8Zm3 1.793L12.707 8 14.5 6.207v3.586ZM8.354 5.646a.5.5 0 0 1 0 .708L6.707 8l1.647 1.646a.5.5 0 0 1-.708.708L6 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L5.293 8 3.646 6.354a.5.5 0 1 1 .708-.708L6 7.293l1.646-1.647a.5.5 0 0 1 .708 0Z" fill="currentColor"/></svg>`,
};
